import React, { useEffect, useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { FaPhoneAlt } from 'react-icons/fa';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import Home from './pages/Home/Home';
import Booking from './pages/Booking/Booking';
import Contact from './pages/Contact/Contact';
import Services from './pages/Services/Services';
import Locations from './pages/Locations/Locations';
import About from './pages/About/About';
import Gallery from './pages/Gallery/Gallery';
import Testimonials from './pages/Testimonials/Testimonials';
import Blog from './pages/Blog/Blog';
import FAQ from './pages/FAQ/FAQ';
import Feedback from './pages/Feedback/Feedback';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService/TermsOfService';
import ServiceDetails from './pages/ServiceDetails/ServiceDetails';
import NotFound from './pages/NotFound/NotFound';

function App() {
  const { pathname } = useLocation();
  const [showCallButton, setShowCallButton] = useState(false);
  const hideCallButton = pathname === '/contact' || pathname === '/booking';

  useEffect(() => {
    const updateButtonVisibility = () => {
      if (hideCallButton) {
        setShowCallButton(false);
        return;
      }

      const threshold = Math.max(120, Math.round(window.innerHeight * 0.75));
      setShowCallButton(window.scrollY > threshold);
    };

    updateButtonVisibility();
    window.addEventListener('scroll', updateButtonVisibility, { passive: true });

    return () => {
      window.removeEventListener('scroll', updateButtonVisibility);
    };
  }, [pathname, hideCallButton]);

  return (
    <div className="flex flex-col min-h-screen">
      <ScrollToTop />
      <Navbar />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:slug" element={<ServiceDetails />} />
          <Route path="/locations" element={<Locations />} />
          <Route path="/about" element={<About />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />

      {/* Mobile floating call button */}
      {showCallButton && (
        <>
          <a
            href="tel:0481577831"
            className="md:hidden fixed bottom-4 right-4 z-50 inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-4 py-2.5 text-xs font-semibold text-white shadow-lg transition-colors duration-200 hover:bg-accent-600"
            aria-label="Call The Skilled Group"
          >
            <FaPhoneAlt className="text-[10px]" />
            Call Us
          </a>

          <a
            href="tel:0481577831"
            className="hidden md:inline-flex fixed bottom-6 right-6 z-50 items-center gap-2 rounded-full bg-accent-500 px-5 py-3 text-sm font-semibold text-white shadow-lg transition-colors duration-200 hover:bg-accent-600"
            aria-label="Call The Skilled Group"
          >
            <FaPhoneAlt className="text-xs" />
            Call Us
          </a>
        </>
      )}
    </div>
  );
}

export default App;